import { getCookie } from "../cookies"
import { setCookie } from "../cookies"
import { removeCookie } from "../cookies"
import displayAmount from "./currencyConverter"
import rangeSlider from "rangeslider-pure"
import loadData from "./loadData";
import updateSliderPosition from "./updateSliderPos"

const calculator = document.querySelector('.calculator');
const culture = document.querySelector('.site-culture').value;

var monthTrans = ' .mån';

if (culture == 'nb') {
    monthTrans = ' mnd.';
}

let sliderAmountCounter = document.querySelectorAll('.calc-loan-amount'),
    sliderMonthCounter = document.querySelectorAll('.calc-loan-term'),
    sliderAmountCounterMin = document.querySelectorAll(".loan-amount--min"),
    sliderAmountCounterMax = document.querySelectorAll(".loan-amount--max"),
    sliderInterestFreeDays = document.querySelectorAll('.calc-loan-total-interest-free-days');

// Get cookie values if present and display frontend & set cookie path so we don't get duplicates
const cookiePath = { path: "/" };
let cookieAmount = getCookie('amount'),
    cookieMonth = getCookie('months'),
    cookieinterestFreeMonthsTotal = getCookie('interestFreeMonthsTotal'),
    cookieInterestFreeDays = getCookie('interestFreeDays');

if (cookieAmount) {
    for (let i = 0; i < sliderAmountCounter.length; i++) {
        sliderAmountCounter[i].innerText = displayAmount(cookieAmount);
    }
} else {
    for (let i = 0; i < sliderAmountCounter.length; i++) {
        let inner = sliderAmountCounter[i].innerText;
        console.log(inner)
        sliderAmountCounter[i].innerText = displayAmount(inner);
    }
}
if (cookieMonth) {
    for (let i = 0; i < sliderMonthCounter.length; i++) {
        sliderMonthCounter[i].innerHTML = cookieMonth + monthTrans
    }
    let interestFreeMonths = document.querySelector('.calc-loan-total-interest-free-months');

    const
        i = 2,
        l = cookieMonth / 12 * i;

    let lFormatted = Math.floor(l);
    if (interestFreeMonths) {
        interestFreeMonths.innerHTML = lFormatted + monthTrans;
    }
}

if (cookieInterestFreeDays) {
    for (let i = 0; i < sliderInterestFreeDays.length; i++) {
        sliderInterestFreeDays[i].innerHTML = cookieInterestFreeDays + ' dage.'
    }
} 

if (calculator) {

    const slider = document.querySelectorAll('input[type="range"]');

    let sliderAmount = document.querySelector("input.slider-amount"),
        sliderAmountMin = sliderAmount.min,
        sliderAmountMax = sliderAmount.max,
        sliderAmountCurrent = sliderAmount.value;
        

    let sliderMonth = document.querySelector("input.slider-month"),
        sliderMonthMin = sliderMonth.min,
        sliderMonthMax = sliderMonth.max,
        sliderMonthCurrent = sliderMonth.value,
        interestFreeMonths = document.querySelector(".calc-loan-total-interest-free-months");

    if (cookieAmount && cookieMonth) {
        sliderAmountCurrent = cookieAmount;
        sliderMonthCurrent = cookieMonth;
        loadData(cookieAmount, cookieMonth)

    } else {
        loadData(sliderAmountCurrent, sliderMonthCurrent)
    }    

    let sliderInterest = document.querySelector('input.slider-interest');        

    if (sliderInterest) {
        let sliderInterestFreeDaysCurrent = sliderInterest.value;           
    }         

    if (interestFreeMonths) {
        let interestFreeMonthsFormatted = interestFreeMonths.innerHTML.split(' ', 1);
    }

    // Format currency min/max
    for (let i = 0; i < sliderAmountCounterMin.length; i++) {
        let sliderAmountMinVal = sliderAmountCounterMin[i].innerHTML;
        sliderAmountCounterMin[i].innerHTML = displayAmount(sliderAmountMinVal);
    }

    for (let i = 0; i < sliderAmountCounterMax.length; i++) {
        let sliderAmountMaxVal = sliderAmountCounterMax[i].innerHTML;
        sliderAmountCounterMax[i].innerHTML = displayAmount(sliderAmountMaxVal);
    }

    // Initialize a new plugin instance for one element or NodeList of elements.

    rangeSlider.create(slider, {
        polyfill: true,
        onInit: function () {
        },
        onSlideStart: function (position, value) {
        },
        onSlide: function (position, value) {

            sliderMonthCurrent = sliderMonth.value;
            sliderAmountCurrent = sliderAmount.value;
            

            if (this.element.classList == "slider-amount") {
                // update displayed amount 
                for (let i = 0; i < sliderAmountCounter.length; i++) {
                    sliderAmountCounter[i].innerHTML = displayAmount(position.toString());
                }

                // Load json data (loaddata(amount, month)
                loadData(position, sliderMonthCurrent)
            } else if (this.element.classList == "slider-month") {
                for (let i = 0; i < sliderMonthCounter.length; i++) {
                    sliderMonthCounter[i].innerHTML = position + monthTrans;
                }
                // Load json data (loaddata(amount, month))
                loadData(sliderAmountCurrent, position)

                if (interestFreeMonths) {
                    // Update interest free months
                    const
                        i = 2,
                        l = position / 12 * i;

                    let lFormatted = Math.floor(l);

                    interestFreeMonths.innerHTML = lFormatted + monthTrans;
                    let interestFreeMonthsFormatted = interestFreeMonths.innerHTML.split(' ', 1);

                    setCookie("interestFreeMonthsTotal", interestFreeMonthsFormatted, cookiePath)
                }
            } else if (this.element.classList == "slider-interest") {
                let interestFreeDays = document.querySelectorAll('.calc-loan-total-interest-free-days');
                //let sliderInterestFreeDaysCurrent = sliderInterest.value;

                for (let i = 0; i < interestFreeDays.length; i++) {
                    interestFreeDays[i].innerHTML = position + " dage";
                }
                
            }
        },
        onSlideEnd: function (position, value) {
            if (this.element.classList == "slider-amount") {
                loadData(position, sliderMonthCurrent)
                setCookie("amount", position, cookiePath)
            } else if (this.element.classList == "slider-month") {
                loadData(sliderAmountCurrent, position)
                setCookie("months", position, cookiePath)
            } else if (this.element.classList == "slider-interest") {
                setCookie("interestFreeDays", position, cookiePath)
            }

            updateSliderPosition();
        }

        
    });

    // Reset cookies with new values
    if (cookieAmount) {
        for (let i = 0; i < sliderAmountCounter.length; i++) {
            sliderAmountCounter[i].innerHTML = displayAmount(cookieAmount);
        }
        sliderAmountCurrent = cookieAmount;
    } else {
        setCookie("amount", sliderAmountCurrent, cookiePath);
    }
    if (cookieMonth) {
        sliderMonthCurrent = cookieMonth;

        for (let i = 0; i < sliderMonthCounter.length; i++) {
            sliderMonthCounter[i].innerHTML = cookieMonth + monthTrans;
        }
    } else {
        setCookie("months", sliderMonthCurrent, cookiePath)
    }

    if (interestFreeMonths) {
        if (cookieinterestFreeMonthsTotal) {
            interestFreeMonths.innerHTML = cookieinterestFreeMonthsTotal + monthTrans;
        }

        else {
            if (interestFreeMonths) {
                let interestFreeMonthsFormatted = interestFreeMonths.innerHTML.split(' ', 1);
                setCookie("interestFreeMonthsTotal", interestFreeMonthsFormatted, cookiePath)
            }
        }
    }

    if (!cookieInterestFreeDays) {
        setCookie("interestFreeDays", "60", cookiePath)
    }
}
updateSliderPosition();





